import React from 'react'
export default function ExampleTemplate1({ primaryColour, textColour, backgroundColour, headingFont, bodyFont, logo }) {
    return (
        <div
            style={{
                backgroundColor: '#eeeeed',
                borderRadius: '12px',
                height: '250px',
                overflow: 'scroll',
                display: 'flex',
                justifyContent: 'center',
                padding: '20px',
                paddingBottom: '0px'
            }}
        >
            <div style={{ width: '100%', backgroundColor: '#FFFFFF' }}>
                <div
                    style={{
                        marginBottom: '12px',
                        width: '100%',
                        backgroundColor: backgroundColour,
                        padding: '5px 10px',
                        lineHeight: '5px',
                        fontSize: '5px',
                        color: '#FFFFFF',
                        display: 'flex',
                        justifyContent: 'space-between'
                    }}
                >
                    <div>May 14 - May 20, 2022</div>
                    <div>View in your browser</div>
                </div>

                <div
                    style={{
                        backgroundColor: '#FFFFFF',
                        padding: '10px',
                        paddingTop: '0px',
                        paddingBottom: '0px',
                        color: textColour
                    }}
                >
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
                        <div>
                            <img
                                src={logo ? logo.url || logo.raw : ''}
                                style={{ width: '100%', maxWidth: '30px', maxHeight: '30px' }}
                            />
                        </div>
                        <div style={{ textAlign: 'right' }}>
                            <img
                                src='https://cdn1.ourmailsender.com/siteContent/assets/templates/socialMediaIcons/twitter-round-black.png?rnd=55704157'
                                style={{ width: '7px', marginRight: '3px' }}
                            />
                            <img
                                src='https://cdn1.ourmailsender.com/siteContent/assets/templates/socialMediaIcons/instagram-round-black.png'
                                style={{ width: '7px', marginRight: '3px' }}
                            />
                            <img
                                src='https://cdn1.ourmailsender.com/siteContent/assets/templates/socialMediaIcons/pinterest-round-black.png'
                                style={{ width: '7px' }}
                            />
                        </div>
                    </div>
                    <img
                        src='https://cdn1.ourmailsender.com/siteContent/brandAnalyzer/example1_img1.png'
                        style={{ width: '100%' }}
                    />
                    <div style={{ marginBottom: '10px' }}>
                        <div
                            style={{
                                fontSize: '7px',
                                marginBottom: '4px',
                                fontWeight: 'bold',
                                lineHeight: '9px',
                                fontFamily: headingFont
                            }}
                        >
                            Hey There! We have some great news for you!
                        </div>
                        <div style={{ fontSize: '5px', marginBottom: '4px', lineHeight: '8px', fontFamily: bodyFont }}>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit.{' '}
                            <a style={{ color: primaryColour }}>Click Here</a>. Aenean auctor cursus eros vel suscipit.
                            Ut eleifend massa ac velit iaculis, nec convallis nisi rutrum. Fusce varius hendrerit arcu.
                        </div>
                        <div
                            style={{
                                backgroundColor: primaryColour,
                                color: 'white',
                                padding: '2px 4px',
                                borderRadius: '5px',
                                fontSize: '8px',
                                display: 'inline-block',
                                lineHeight: '10px',
                                fontFamily: bodyFont
                            }}
                        >
                            Call to action button
                        </div>
                    </div>

                    <div style={{ backgroundColor: primaryColour, padding: '5px' }}></div>
                </div>
            </div>
        </div>
    )
}
